module.exports = __webpack_public_path__ + "img/学校-选中.55934a88.png";